"use client";
import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';

const CLASH = 'var(--font-clash), "Clash Display", sans-serif';
const MANROPE = 'var(--font-manrope), Manrope, sans-serif';
const LIME = '#ceff1a';

const links = [
    { label: 'Google Ads Management', href: '/services/performance-marketing/google-ads' },
    { label: 'Meta Ads Management', href: '/services/performance-marketing/meta-ads' },
];

export default function CROWorksWithPerformance() {
    return (
        <section className="relative overflow-hidden py-20 md:py-28 px-6 md:px-16 lg:px-24" style={{ background: '#080400' }}>
            <div className="max-w-[900px] mx-auto relative z-10 flex flex-col gap-6">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: LIME, fontFamily: CLASH }}
                >
                    Works Better Together
                </motion.span>

                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="text-3xl md:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: CLASH, color: '#fbfdfd' }}
                >
                    CRO Works Best With Performance Marketing
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="flex flex-col gap-5"
                >
                    <p className="text-base md:text-lg leading-relaxed" style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}>
                        Paid acquisition and conversion optimisation should not operate in separate rooms.
                    </p>
                    <p className="text-base md:text-lg leading-relaxed" style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}>
                        Bringing more qualified visitors to a page is only half the job. The other half is making sure the experience gives them a compelling reason to continue.
                    </p>
                    <p className="text-base md:text-lg leading-relaxed" style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}>
                        That&apos;s why our CRO work connects closely with Google Ads, Meta Ads, landing pages and marketing analytics.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.35 }}
                    className="flex flex-wrap items-center gap-3 pt-2"
                >
                    {links.map((l) => (
                        <Link
                            key={l.href}
                            href={l.href}
                            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-colors duration-200 hover:bg-white/10"
                            style={{ border: '1px solid rgba(255,255,255,0.16)', color: '#ffffff', fontFamily: MANROPE }}
                        >
                            {l.label}
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                <path d="M2 6.5h9M7.5 2.5l4 4-4 4" stroke={LIME} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Link>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
